// extracted by mini-css-extract-plugin
export var row = "_v7-0";